import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { doGet, doPut } from '../../../config/fetchWrapper'
import { urls } from '../../endPoints'

export const getPrioritizedSource = createAsyncThunk('GetPrioritizedSource', async (arg, { rejectWithValue }) => {
    try {
        const response = await doGet(`${urls?.getPrioritizedSource}/${arg}`)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

export const getPrioritizedSourceSlice = createSlice({
    name: 'GetPrioritizedSource',
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        getPrioritizedSourceReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        },
    },
    extraReducers: {
        [getPrioritizedSource.pending]: (state) => {
            state.isLoading = true
            state.success = false
            state.error = null
        },
        [getPrioritizedSource.fulfilled]: (state, { payload }) => {
            state.isLoading = false
            state.success = true
            state.data = payload
            state.error = null
        },
        [getPrioritizedSource.rejected]: (state, { payload }) => {
            state.isLoading = false
            state.error = payload
            state.data = false
        },
    },
})

export const updateSourcePriority = createAsyncThunk('UpdateSourcePriority', async (arg, { rejectWithValue }) => {
    try {
        const response = await doPut(urls?.updateSourcePriority, arg)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

export const updateSourcePrioritySlice = createSlice({
    name: 'UpdateSourcePriority',
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        updateSourcePriorityReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        },
    },
    extraReducers: {
        [updateSourcePriority.pending]: (state) => {
            state.isLoading = true
            state.success = false
            state.error = null
        },
        [updateSourcePriority.fulfilled]: (state, { payload }) => {
            state.isLoading = false
            state.success = true
            state.data = payload
            state.error = null
        },
        [updateSourcePriority.rejected]: (state, { payload }) => {
            state.isLoading = false
            state.error = payload
            state.data = false
        },
    },
})

export const { getPrioritizedSourceReset } = getPrioritizedSourceSlice.actions
export const { updateSourcePriorityReset } = updateSourcePrioritySlice.actions
